var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Spacer',{staticClass:"typo--3",attrs:{"bottom":"xs"}},[_vm._v(" "+_vm._s(_vm.$labels[_vm.data.value])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }